module.exports = __webpack_public_path__ + "img/engineering.9ce180f7.svg";